import { cloneElement } from 'react';
import cookie from 'react-cookies';
import ReactPixel from 'react-facebook-pixel';
import BranchProvider, {
    useBranch,
} from '../../../../providers/BranchProvider';
import { useBrowserDetails } from '../../../../services/browserDetails/context';
import theme from '../../../../theme';
import { getOS } from '../../../../util/isIOS';
import { PrimaryCTA } from '../../../Onboarding/PrimaryCTA';
import { Body, BodyBold } from '../../../Text';
import {
    flushExternal,
    onWebAppVisitAppStore,
} from '../../../../tracking/trackers';

const SubAppCard = ({ subApp, isMobile }: any) => {
    // const { link } = useBranch();

    const handleClick = async () => {
        if (subApp.redirectToStores) {
            return downloadApp(subApp);
        }

        if (isMobile) {
            window.location.href = '/download-apps';
            return;
        }

        window.location.href = `/send-download-link?link=https://simplywise.com/download-apps&app-name=${subApp.name}`;

        // if (!link) return;

        // if (isMobile) {
        //     onWebAppVisitAppStore({
        //         source: 'home',
        //     });
        //     await flushExternal();
        //     if (process.env.NODE_ENV === 'development') {
        //         console.debug('Tracked Play Store View');
        //     }
        //     ReactPixel.track('Lead', {
        //         content_category: '',
        //         content_name: '',
        //     });
        //     window.location.href = link;
        //     return;
        // }

        // window.location.href = `/send-download-link?link=${link}&app-name=${subApp.name}`;
    };

    const getAppDownloadLink = (subApp: any) => {
        const os = getOS();
        return os === 'macos' || os === 'ios'
            ? subApp.appStoreLink?.length
                ? subApp.appStoreLink
                : subApp.playStoreLink?.length
                ? subApp.playStoreLink
                : subApp.url ?? '/'
            : subApp.playStoreLink?.length
            ? subApp.playStoreLink
            : subApp.appStoreLink?.length
            ? subApp.appStoreLink
            : subApp.url ?? '/';
    };

    const downloadApp = (subApp: any) => {
        window.location.href = getAppDownloadLink(subApp);
    };

    const renderHeroImage = (subApp: any, isMobile: boolean) => {
        if (!subApp.heroImage) return null;

        if (isMobile) {
            return (
                <div
                    style={{
                        display: 'flex',
                        position: 'absolute',
                        top: -120,
                        justifyContent: 'center',
                        overflow: 'hidden',
                        height: 340,
                        width: '100%',
                        borderTopRightRadius: 10,
                        borderTopLeftRadius: 10,
                    }}
                >
                    <div
                        style={{
                            height: 400,
                            width: '100%',
                            display:
                                subApp.name === 'A.I. Receptionist'
                                    ? 'flex'
                                    : undefined,
                            justifyContent:
                                subApp.name === 'A.I. Receptionist'
                                    ? 'center'
                                    : undefined,
                            alignItems:
                                subApp.name === 'A.I. Receptionist'
                                    ? 'center'
                                    : undefined,
                        }}
                    >
                        <div
                            style={{
                                height: 220,
                                width: '100%',
                                display:
                                    subApp.name === 'A.I. Receptionist'
                                        ? 'flex'
                                        : undefined,
                                justifyContent:
                                    subApp.name === 'A.I. Receptionist'
                                        ? 'center'
                                        : undefined,
                                alignItems:
                                    subApp.name === 'A.I. Receptionist'
                                        ? 'center'
                                        : undefined,
                                position: 'absolute',
                                bottom: 0,
                                borderTopRightRadius: 10,
                                borderTopLeftRadius: 10,
                                backgroundColor: '#DEDCDA',
                                zIndex: 1,
                            }}
                        />
                        <div
                            style={{
                                height: 400,
                                width: '100%',
                                position: 'relative',
                                zIndex: 2,
                                display:
                                    subApp.heroImage.type === 'img'
                                        ? 'flex'
                                        : undefined,
                                justifyContent:
                                    subApp.heroImage.type === 'img'
                                        ? 'center'
                                        : undefined,
                                alignItems:
                                    subApp.heroImage.type === 'img'
                                        ? 'center'
                                        : undefined,
                            }}
                        >
                            {subApp.heroImage.type === 'img'
                                ? cloneElement(subApp.heroImage, {
                                      width: '20%',
                                  })
                                : subApp.heroImage}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div
                style={{
                    width: '46%',
                    backgroundColor: '#DEDCDA',
                    display:
                        subApp.name === 'A.I. Receptionist' ? 'flex' : 'block',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {subApp.heroImage}
            </div>
        );
    };

    const renderBulletPoints = (subApp: any) => {
        if (!subApp.bulletPoints?.length) return null;

        return (
            <div style={{ marginBottom: 20 }}>
                {subApp.bulletPoints.map((bp: string, index: number) => (
                    <div
                        key={`bullet-${index}`}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'baseline',
                            marginTop: 8,
                            width: '100%',
                            padding: '0px 10px',
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    display: 'flex',
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: theme.colors.secondary,
                                    marginRight: 8,
                                }}
                            />
                        </div>
                        <Body
                            style={{
                                color: 'rgba(24, 28, 63, 0.7)',
                                fontFamily: 'inter',
                            }}
                        >
                            {bp}
                        </Body>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div
            style={{
                marginTop: isMobile ? 40 : 20,
                marginBottom: 40,
                cursor: 'pointer',
                position: 'relative',
            }}
        >
            <div
                onClick={handleClick}
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    borderRadius: 10,
                    width: isMobile ? '85vw' : '100%',
                    height: isMobile ? 'fit-content' : 500,
                    backgroundColor: theme.colors.offWhite,
                    padding: isMobile ? '0px 0px 40px 0px' : '0px',
                    overflow: isMobile ? 'unset' : 'hidden',
                    position: 'relative',
                    alignSelf: 'center',
                }}
            >
                {renderHeroImage(subApp, isMobile)}
                <div
                    style={{
                        display: 'flex',
                        padding: isMobile ? '0px 30px' : '120px 60px',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: isMobile ? 265 : 0,
                        height: isMobile ? '59%' : '100%',
                        width: isMobile ? '100%' : '50%',
                        zIndex: 1,
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            width: 'auto',
                            margin: '20px 0px',
                        }}
                    >
                        <img
                            alt={subApp.icon?.props.alt}
                            src={subApp.icon?.props.src}
                            style={{
                                width: 40,
                                height: 40,
                                marginRight: 10,
                            }}
                        />
                        <BodyBold
                            style={{
                                fontSize: isMobile ? 15 : 25,
                                color: theme.colors.primary,
                                fontFamily: 'inter',
                            }}
                        >
                            {subApp.name}
                        </BodyBold>
                    </div>
                    <BodyBold
                        style={{
                            color: theme.colors.primary,
                            fontSize: isMobile ? 25 : 35,
                            marginBottom: 20,
                            fontWeight: 'bold',
                            fontFamily: 'inter',
                            lineHeight: 1.2,
                        }}
                    >
                        {subApp.title}
                    </BodyBold>
                    {renderBulletPoints(subApp)}
                    <PrimaryCTA
                        onClick={() => downloadApp(subApp)}
                        size={'normal'}
                        label={'Download'}
                        style={{
                            backgroundColor: theme.colors.secondary,
                            color: 'white',
                            padding: isMobile ? '10px 15px' : '12px 24px',
                            borderRadius: 100,
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            marginTop: 20,
                            fontFamily: 'inter',
                            fontSize: isMobile ? 14 : 16,
                            transition: 'background-color 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

const SubAppBranchWrapper = ({
    subApp,
    isMobile,
    webUrl,
    children,
}: {
    subApp: any;
    isMobile: boolean;
    webUrl?: string | null;
    children?: React.ReactNode;
}) => {
    const { ipAddress, userAgent } = useBrowserDetails();

    webUrl = webUrl ?? localStorage.getItem('originWebUrl');
    const branchData = {
        visitor_id: localStorage.getItem('visitor_id'),
        origin_web_url: webUrl,
        web_url: webUrl,
        referrer_mobile: localStorage.getItem('referrer_mobile'),
        referral_cohort: localStorage.getItem('referral_cohort'),
        general_attribution_id: localStorage.getItem('general_attribution_id'),
        facebook_browser_id: cookie.loadAll()._fbp,
        facebook_click_id: cookie.loadAll()._fbc,
        ip_address: ipAddress,
        user_agent: userAgent,
        ...(subApp.appStoreLink ? { $ios_url: subApp.appStoreLink } : {}),
        ...(subApp.playStoreLink ? { $android_url: subApp.playStoreLink } : {}),
        // ...(customData || {}),
    };

    return (
        <BranchProvider
            data={{
                data: branchData,
            }}
            appId={subApp.appId}
        >
            {children ?? <SubAppCard subApp={subApp} isMobile={isMobile} />}
        </BranchProvider>
    );
};

export default SubAppBranchWrapper;
